import UIBox from 'UIComponents/layout/UIBox';
import UISelect from 'UIComponents/input/UISelect';
import { getRoutingTypeOptions } from '../constants/RoutingRulesSelectOptions';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { useCallback } from 'react';
import { KEEP_ASSIGNEE } from '../constants/RoutingTypes';
import NoAccessToInboxTooltip from './tooltips/NoAccessToInboxTooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const SelectAssignmentGroup = ({
  anyAvailableUser,
  currentGroup,
  disabled,
  disableKeepAssignee,
  onChange,
  onOpenChange,
  aiChatbotId,
  showAnyUser,
  showKeepAssignee,
  showUnassigned,
  showOwner
}) => {
  const {
    openUpgradeModal
  } = useUpgradeModal('livemessages-routing');
  const itemComponent = useCallback(itemComponentProps => {
    if (disableKeepAssignee && itemComponentProps.option.value === KEEP_ASSIGNEE) {
      return /*#__PURE__*/_jsx(NoAccessToInboxTooltip, {
        children: itemComponentProps.children
      });
    }
    return /*#__PURE__*/_jsx(_Fragment, {
      children: itemComponentProps.children
    });
  }, [disableKeepAssignee]);
  return /*#__PURE__*/_jsx(UIBox, {
    basis: 240,
    grow: 0,
    children: /*#__PURE__*/_jsx(UISelect, {
      className: "select-assignment-group",
      disabled: disabled,
      defaultOpen: false,
      itemComponent: itemComponent,
      options: getRoutingTypeOptions({
        anyAvailableUser,
        disableKeepAssignee,
        showAnyUser,
        showKeepAssignee,
        showUnassigned,
        showOwner,
        aiChatbotId
      }),
      searchable: false,
      value: currentGroup,
      menuWidth: 250,
      onChange: onChange,
      onOpenChange: onOpenChange,
      onSelectedOptionChange: e => {
        if (e.target.value.locked) {
          openUpgradeModal();
        }
      }
    })
  }, currentGroup);
};
SelectAssignmentGroup.displayName = 'SelectAssignmentGroup';
export default SelectAssignmentGroup;